import React, { useState, Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useAsyncError, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Form, Dropdown } from "react-bootstrap";
import { getAssetlist } from "../../Actions/axios";

const AssetList = () => {
  const navigate = useNavigate();

  const [AssetList, setAssetList] = useState([]);
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(1);
  console.log("🚀 ~ AssetList ~ page:", page, AssetList.length);
  const [searchtext, setSearchtext] = useState("");
  const [type, setType] = useState("crypto");
  const [totalCount, setTotalCount] = useState(0);
  const [status, setStatus] = useState(true);

  const getAssets = async (cur_page, cur_limit) => {
    let sendData = {
      page: (cur_page || page) - 1,
      limit: cur_limit || limit,
      type,
      searchtext,
    };
    let resp = await getAssetlist(sendData);
    if (resp?.status) {
      setAssetList([...resp?.data?.data]);
      setTotalCount(resp?.data?.count);
    }
  };

  const columns = [
    {
      name: "S.no",
      align: "left",
      sortable: false,
      selector: (row, i) => <p>{i + 1}</p>,
    },
    {
      name: "Email Id",
      key: "emailid",
      align: "left",
      sortable: false,
      selector: (row) => <p>{row.emailid}</p>,
    },
    {
      name: "Status",
      key: "status",
      align: "left",
      sortable: false,
      selector: (row) => <p>{row.status}</p>,
    },
    {
      name: "Action",
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className={`btn sitebtn btn-sm ${record._id}`}
              onClick={() =>
                navigate("/assetDetail", {
                  state: {
                    ...record,
                    application: {
                      ...record["application"],
                      ...(record["type"] == "crypto"
                        ? {
                            category: record?.category?.name,
                            network: record?.network?.name,
                            subcategory : record?.subcategory?.name
                          }
                        : {}),
                    },
                  },
                })
              }
            >
              <FaEdit />
            </button>
          </Fragment>
        );
      },
    },
  ];

  useEffect(() => {
    getAssets();
  }, [searchtext, type, page, limit]);

  return (
    <div className="cmslist">
      <h1 className="pagehead">Asset List</h1>
      <div className="cardbox">
        <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
          <Dropdown
            className="reqdrop"
            onSelect={(e) => {
              setType(e);
            }}
          >
            <Dropdown.Toggle
              className="w-100 text-start"
              variant="success"
              id="dropdown-basic"
            >
              {type == "" ? "Select Type" : type}
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100">
              {["crypto", "exchange"]?.map((val) => (
                <Dropdown.Item eventKey={val}>{val}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <Form>
            <Form.Control
              type="text"
              onChange={(e) => setSearchtext(e.target.value)}
              placeholder="Search"
            />
          </Form>
          {/* <Link to="/assetadd" className="btn sitebtn">
            Add
          </Link> */}
        </div>
        {/* {status && ( */}
        <div className="tablebox">
          <DataTable
            className="react-datatables"
            columns={columns}
            data={AssetList}
            pagination={true}
            paginationTotalRows={totalCount}
            paginationPerPage={limit}
            paginationServer
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
            onChangeRowsPerPage={(e) => setLimit(e)}
            onChangePage={(e, total) => {
              console.log("dfaywfdawdf", e, total);
              setPage(e);
              // getAssets(e + 1);
            }}
          />
        </div>
        {/* // )} */}
      </div>
    </div>
  );
};

export default AssetList;
